import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Form, Select } from 'antd';
import { capitalizeAndTranslateMsg } from '../../../mainUtils';

function ChangeTypeOfUserBtn({
  changeTypeOfUserCallback,
  defaultUserType,
  disabled,
}) {
  const [localUserType, setLocalUserType] = useState(defaultUserType);

  const onChange = (value) => {
    setLocalUserType(value);

    if (changeTypeOfUserCallback) {
      changeTypeOfUserCallback(value);
    }
  };

  useEffect(() => {
    setLocalUserType(defaultUserType);
  }, [defaultUserType, disabled]);

  return (
    <Form.Item
      label={capitalizeAndTranslateMsg('auth.headers.user type', 'type of user')}
      name="typeOfUser"
    >
      <Select
        onChange={onChange}
        options={[
          {
            value: localUserType === 'user' ? 'classic_user' : 'user',
            label: localUserType === 'user' ? 'classic user' : 'user',
          },
        ]}
        disabled={disabled}
      />
    </Form.Item>
  );
}

export default ChangeTypeOfUserBtn;

ChangeTypeOfUserBtn.propTypes = {
  changeTypeOfUserCallback: PropTypes.func,
  defaultUserType: PropTypes.string,
  disabled: PropTypes.bool,
};
